import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Progress, Typography, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getScoreCardStyles } from '../../IngressCardWidgetStyles';
export var Score = props => {
  var scoreValue = props.scoreValue,
    color = props.color,
    progressBackgroundColor = props.progressBackgroundColor,
    minScore = props.minScore,
    maxScore = props.maxScore,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'IngressCardWidget' : _props$testID;
  var scoreCardStyles = getScoreCardStyles();
  var calculateProgressValue = (value, minValue, maxValue) => (value - minValue) / (maxValue - minValue) * 100;
  var progressBarValue = minScore && maxScore ? calculateProgressValue(scoreValue, minScore, maxScore) : scoreValue;
  return _jsx(View, Object.assign({
    style: scoreCardStyles.container
  }, {
    children: _jsxs(View, {
      children: [_jsx(Progress, Object.assign({
        type: "circular",
        size: "lg",
        value: progressBarValue,
        progressColor: color,
        progressBackgroundColor: progressBackgroundColor,
        customSize: 60
      }, getTestId(testID, 'Progress'))), scoreValue ? _jsx(View, Object.assign({
        style: scoreCardStyles.textContainer
      }, {
        children: _jsx(Typography, Object.assign({
          text: scoreValue.toString(),
          color: color,
          type: "body-para-md-bold"
        }, getTestId(testID, 'Value')))
      })) : null]
    })
  }));
};